export const modalTestId = 'quick-action-modal';
export const formName = 'quick-action';
export const FIELD_NAME = {
  CURRENCY: 'Currency',
  LOCALE: 'Locale',
};
